import {createFileRoute, useParams} from '@tanstack/react-router';
import {CardPage} from 'pages/accounts/credits/card';

const CardPageRoute = () => {
  const {cardId} = useParams({from: '/_protected/home/accounts/cards/$cardId'});
  return <CardPage cardId={cardId} />;
};

export const Route = createFileRoute('/_protected/home/accounts/cards/$cardId')(
  {
    component: CardPageRoute,
    staticData: {crumbKey: 'navigation.card'},
  },
);
